import { Component } from '@angular/core';

import { Breadcrumb } from '../../../models/bread-crumb.model';
import { BreadCrumbService } from '../../../services/bread-crumb/bread-crumb.service';

import { Observable } from 'rxjs';

@Component({
  selector: 'cube-bread-crumb-toolbar',
  templateUrl: './bread-crumb-toolbar.component.html',
  styleUrls: ['./bread-crumb-toolbar.component.scss'],
  standalone: false,
})
export class BreadCrumbToolbarComponent {
  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(private readonly breadcrumbService: BreadCrumbService) {
    this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
  }
}
